import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Modal, ModalHeader, ModalBody, Row, Col, Button } from 'reactstrap';
import { authenticationService } from 'services/authentication.service';
import config from "config.json"
import { authHeader } from 'helpers/auth-header';
import { alertService } from './alert_service';

import "../../assets/scss/ModalTiempoSesion/modalSesion.scss"


export type PropsModalTiempoSesion = {
    show: boolean,
    tokenUser: string,
    onClose: () => void
}


export default function ModalTiempoSesion(props: PropsModalTiempoSesion) {

    const [remainingTime, setRemainingTime] = useState<number>(60); // 60 seconds initially


    useEffect(() => {

        if (props.show === true) {
            const timeoutId  = setTimeout(() => {
                if(remainingTime > 0 && !document.hidden){
                    setRemainingTime(remainingTime - 1);
                }
                else if(remainingTime > 0 && document.hidden) {
                    setRemainingTime(remainingTime - 3);
                }
            }, 1000); // Update every second (1000 milliseconds)

            // Cleanup function to clear interval
            return () => clearTimeout(timeoutId );
        }

    }, [props.show,remainingTime])

    const onTimerEnd = () => {
        authenticationService.logout();
        // console.log("me deslogueee")
        props.onClose();
    }

    useEffect(() => {
        if (remainingTime === 0) {
            onTimerEnd(); // Call the provided function
        }
    }, [remainingTime, onTimerEnd]);

    async function HandleClickUpdateSessionTime() {
        try {
            const URL_UPDATE_SESSION_TIME = config.SERVER_URL + "Account/UpdateSessionTime";
            const respuesta = await axios.put(URL_UPDATE_SESSION_TIME, {}, {
                headers: authHeader()
            })

            const tiempoUpdate = respuesta.data;
            authenticationService.UpdateSessionTime(tiempoUpdate.fechaVencimiento, tiempoUpdate.fechaComparar);
            
            props.onClose()
            setRemainingTime(60)

        } catch (error) {
            alertService.error("Ha ocurrido un inconveniente");
            onTimerEnd();
        }
    }

    return (
        <Modal
            id="ModalActualizarSessionTime"
            isOpen={props.show}
            scrollable={true}
            size={"md"}
            fullscreen={"md"}
            centered
        >
            <ModalHeader>
                Mensaje del sistema
            </ModalHeader>
            <ModalBody>
                <Row className="containerModalTiempoSesion">
                    <Col>

                        <div>Su tiempo de sesión esta a punto de expirar.</div>
                        <div className="text2Sesion">¿Desea mantener su sesión activa?</div>
                        <div>{remainingTime > 0 && remainingTime}</div>

                    </Col>
                </Row>
                <Row className='justify-content-center'>
                    <Col md={6} className="text-right">
                        <Button className="no-float" onClick={() => HandleClickUpdateSessionTime()}> Continuar sesión</Button>
                    </Col>
                    <Col md={6} className="text-left">

                        <Button className=" btnEspolred no-float" onClick={() => onTimerEnd()}>Cerrar sesión</Button>


                    </Col>


                </Row>

            </ModalBody>
        </Modal>
    )
}
